import classes from './card.module.css'

// Fill and border come from the Paper override; this only covers sections.
const Card = {
  classNames: {
    section: classes.section,
  },
}

export default Card
